export default {"src":"/_next/static/media/rapture-logo.a22bcf7c.svg","height":53,"width":53};